import { render, staticRenderFns } from "./MetricsSupport.vue?vue&type=template&id=f02552a4&scoped=true"
import script from "./MetricsSupport.vue?vue&type=script&lang=js"
export * from "./MetricsSupport.vue?vue&type=script&lang=js"
import style0 from "./MetricsSupport.vue?vue&type=style&index=0&id=f02552a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02552a4",
  null
  
)

export default component.exports